import { useState } from 'react';
import {
  ModalInfo,
  Section,
  SelectContent,
  Option,
} from './SelectModal.styles';
import BottomModal from '../../../components/modal/BottomModal';
import {
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  CancleButton,
  ConfirmButton,
} from '../../../components/modal/Modal.style';
import { auctionDateYearsOptions } from '../data';

interface PurposeModalProps {
  setModalOn: (v: boolean) => void;
  selected: string;
  onApply: (selected: string) => void;
}

const PurposeModal = ({ setModalOn, selected, onApply }: PurposeModalProps) => {
  const [selectedItem, setSelectedItem] = useState<string>(selected);

  const toggleItem = (item: string) => {
    setSelectedItem(item);
  };
  const isChecked = (value: string) => selectedItem === value;

  const handleApply = () => {
    onApply(selectedItem);
    setModalOn(false);
  };

  return (
    <BottomModal onClose={() => setModalOn(false)}>
      <ModalHeader>
        <ModalTitle>사례분석</ModalTitle>
        <ModalCloseButton
          onClick={() => setModalOn(false)}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Section $gap={16}>
        <ModalInfo>관심있는 물건 종류를 선택해주세요</ModalInfo>
        <SelectContent>
          {auctionDateYearsOptions.map((option) => (
            <Option key={option.label} $active={isChecked(option.value)}>
              <label>
                <input
                  type="checkbox"
                  checked={isChecked(option.value)}
                  onChange={() => toggleItem(option.value)}
                />
                {option.label}
                {isChecked(option.value) && (
                  <img
                    src="/assets/images/check/blue_check_24.svg"
                    onClick={() => toggleItem(option.value)}
                    alt=""
                  />
                )}
              </label>
            </Option>
          ))}
        </SelectContent>
      </Section>
      <ModalFooter>
        <CancleButton onClick={() => setModalOn(false)}>취소</CancleButton>
        <ConfirmButton $disabled={selectedItem === ''} onClick={handleApply}>
          적용
        </ConfirmButton>
      </ModalFooter>
    </BottomModal>
  );
};

export default PurposeModal;
